<template>
  <v-row
    class="mb-4 mt-4"
    ><v-spacer />

    <v-col lg="4" md="5" sm="6" cols="12">
      <v-card elevation="2">
        <div class="d-flex align-center error-container">
          <!--<v-card color="red" elevation="0" width="7" height="50px" />-->
          <v-icon color="error" class="ma-2" icon="error_outline" />

          {{ message }}
          <v-spacer />
          <v-btn icon size="x-small" class="circle" variant="plain" @click="closeTabError"
            ><v-icon class="circle" size="small" icon="close" /></v-btn
          >
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "StoreLocations",

  props: {
    message: String,
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {
    closeTabError() {
      this.$emit("close-tab-error");
    },
  },
};
</script>

<style scoped>
.circle {
  height: 20px !important;
  width: 20px !important;
  border-radius: 100px !important;
}

.error-container {
  min-height: 60px;
  padding-left: 8px;
  padding: 12px;
}
</style>

